import React,{Component} from 'react';
import TextField from "@material-ui/core/TextField";
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import SimpleReactValidator from "simple-react-validator";
import Api from "../../../libraries/api";
import Default from "../../../images/default.jpeg";
import Button from '@material-ui/core/Button';
import {toast, ToastContainer} from "react-toastify";
import {history} from "../../../shared/configure-store";
import AuthHelper from "../../../libraries/auth-helper";
require('dotenv').config();
const validator = new SimpleReactValidator();

class MenusEditFooter extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            loadingImage: false,
            errors: {},

            types: [],
            menus: [],

            parentId: null,
            id: '',
            name: '',
            link: '',
            group: '',
            active: false,
            photo: Default,

            isManage: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Gudangemas - Ubah Menu Footer';

        let profile = AuthHelper.getProfile();
        if(profile['map-menu']) {
            let roles = profile['map-menu'].map(o => {
                return {
                    id: o.id,
                    name: o.menu.name,
                    isCreate: o.isCreate,
                    isManage: o.isManage,
                }
            });

            let all = roles.filter((item) => item.name === 'Menus');

            if (all.length > 0) {
                this.setState({
                    isManage: all[0] ? all[0].isManage : false
                });
            }
        }

        const id = this.props.match.params.id;

        Api.get('/menu/footer/'+id).then(resp => {

            if (resp.data) {
                this.setState({
                        id: resp.data.id,
                        name: resp.data.name,
                    link: resp.data.link,
                    group: resp.data.group,
                        loading: false
                    }
                );
            }

        }).catch(err => {
            console.log(err);
        });
    }

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleDate (date, prop){

        this.setState({

            [prop]: date

        })

    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSubmit = (e) => {

        e.preventDefault();

        if (!validator.allValid()) {

            this.setState({
                    errors: validator.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loadingButton: true,
            }
        );

        let params = {
            'id': this.state.id,
            'group': this.state.group,
            'name': this.state.name,
            'link': this.state.link,
        };


        Api.put('/menu/footer', params).then(resp => {
            if(resp.status === 200) {
                history.push('/menus');
                this.showMessage(true, 'Menu berhasil ditambah');
            }else {
                this.showMessage(false, resp.message[0]);
            }
            this.setState({
                    loadingButton: false,
                }
            );

        }).catch(err => {

            this.setState({
                    errors: err.errors,
                    loadingButton: false
                }
            );

            this.showMessage(false, 'Invalid format data');
        });

    };

    handleGo  = (link) => {

        history.push(link);
    };


    handleChecked = e => {

        this.setState({

            active: e.target.checked,

        })

    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Footer Menu</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/menus" >Footer</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Tambah</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Footer Menu</h2>
                            </div>
                        </div>
                        <h3 className='section-title'> </h3>

                        <form name="menus" id="addMenusFooter" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Grup Menu</label>
                                    <TextField variant="outlined"
                                               select
                                               id="group"
                                               name="group"
                                               label="Grup"
                                               onChange={(e) => this.handleChange(e, 'group')}
                                               value={this.state.group}
                                               fullWidth
                                    >
                                        <MenuItem value='GE Best Friend'>GE Best Friend</MenuItem>
                                        <MenuItem value='Tautan'>Tautan</MenuItem>
                                        <MenuItem value='Social Media'>Social Media</MenuItem>
                                    </TextField>
                                    {validator.message('group', this.state.group, 'required')}
                                    <div className='text-danger'>{this.state.errors.group}</div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nama Menu</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='name'
                                               name="name"
                                               label="Nama Menu"
                                               onChange={(e) => this.handleChange(e, 'name')}
                                               value={this.state.name}
                                               fullWidth
                                    />
                                    {validator.message('name', this.state.name, 'required')}
                                    <div className='text-danger'>{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Link URL</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='link'
                                               name="link"
                                               label="Link"
                                               onChange={(e) => this.handleChange(e, 'link')}
                                               value={this.state.link}
                                               fullWidth
                                    />
                                    {validator.message('link', this.state.link, 'required')}
                                    <div className='text-danger'>{this.state.errors.link}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button
                                    className="mr-3"
                                    variant="contained"
                                    onClick={() => this.handleGo('/menus')}
                                >
                                    Batal
                                </Button>
                                {this.state.isManage &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton}
                                >
                                    Simpan { this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>

                                }

                            </div>
                        </form>
                    </div>

                </div>
                <ToastContainer />

            </div>
        )
    }
}

export default MenusEditFooter;
